import { render } from "./Contador.vue?vue&type=template&id=0a93fe4a&scoped=true"
import script from "./Contador.vue?vue&type=script&lang=js"
export * from "./Contador.vue?vue&type=script&lang=js"

import "./Contador.vue?vue&type=style&index=0&id=0a93fe4a&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Public\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a93fe4a"]])

export default __exports__